import { render, staticRenderFns } from "./PayPalBtn.vue?vue&type=template&id=6b16a95a&"
import script from "./PayPalBtn.vue?vue&type=script&lang=js&"
export * from "./PayPalBtn.vue?vue&type=script&lang=js&"
import style0 from "./PayPalBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports